import { useEffect } from "react";
import ReactLoading from "react-loading";
import Breadcrumb from "../../../components/breadcrumb";
import Footer from "../../../components/footer";
import PageBackgroundPattern from "../../../components/PageBackgroundPattern";
import HistorialHeader from "../components/HistorialHeader";
import HistorialPagination from "../components/HistorialPagination";
import HistorialTable from "../components/HistorialTable";
import useHistorialData from "../hooks/useHistorialData";

function Historial() {
    const {
        isLoading,
        isError,
        currentPage,
        setCurrentPage,
        totalPages,
        totalItems,
        totalAvailable,
        searchTerm,
        setSearchTerm,
        sortBy,
        sortDirection,
        onSortChange,
        pagedHistorial,
        range,
    } = useHistorialData();

    useEffect(() => {
        document.title = "Historial";
    }, []);

    return (
        <div className="relative min-h-screen overflow-hidden bg-[#062a1a] pt-16">
            <PageBackgroundPattern />
            <main className="relative z-10 max-w-7xl mx-auto w-full px-3 sm:px-4 md:px-10 pt-2 pb-6 sm:pb-8 md:pb-10">
                <Breadcrumb
                    items={[
                        { label: "Inicio", to: "/" },
                        { label: "Historial", isCurrent: true },
                    ]}
                    className="mb-3 sm:mb-4"
                />

                <HistorialHeader
                    totalItems={totalItems}
                    totalAvailable={totalAvailable}
                    range={range}
                    searchTerm={searchTerm}
                    onSearchTermChange={setSearchTerm}
                />

                {isLoading && (
                    <div className="rounded-xl border border-white/10 bg-[#102216] p-6 sm:p-10">
                        <ReactLoading type="bars" color="#22c55e" width={60} className="text-center m-auto mb-6 sm:mb-10 sm:[&>div]:!w-[80px]" />
                        <p className="text-center text-slate-200 text-base sm:text-lg font-semibold">Cargando historial...</p>
                    </div>
                )}

                {isError && !isLoading && (
                    <div className="rounded-xl border border-red-400/30 bg-red-950/20 p-6 sm:p-8 text-center text-red-200 text-sm sm:text-base font-medium">
                        No se pudo cargar el historial en este momento.
                    </div>
                )}

                {!isLoading && !isError && (
                    <>
                        <HistorialTable
                            rows={pagedHistorial}
                            sortBy={sortBy}
                            sortDirection={sortDirection}
                            onSortChange={onSortChange}
                        />

                        <HistorialPagination
                            currentPage={currentPage}
                            totalPages={totalPages}
                            onPageChange={setCurrentPage}
                        />

                        <p className="text-xs sm:text-sm text-slate-400 font-medium mt-3 sm:mt-4 text-center">
                            Mostrando <span className="text-slate-100">{range.start}</span> a <span className="text-slate-100">{range.end}</span> de <span className="text-slate-100">{totalItems}</span> resultados.
                        </p>
                    </>
                )}
            </main>

            <div className="relative z-10">
                <Footer />
            </div>
        </div>
    );
}

export default Historial;
